module.exports = __webpack_public_path__ + "static/trajes-31af2594dace64db770fd7e29337c791.png";